/**
 * Тип порта в форме правки — номер справочника `modem/type`.
 *
 * Строка «Сетевых портов» несёт тип **именем** модели — так его отдаёт `modem/list` (и Kraken, и Midori;
 * `network_ports_snapshot.py`), а пункты поля «Тип модема» — номера. Без перевода имя не совпадало ни с одним
 * пунктом, и поле показывало «Выберите тип модема» у любого порта (MANAGER_BUGS D23, 28.10).
 *
 * Имя, которого в справочнике нет, остаётся как есть: заглушка честнее выдуманной модели.
 */
export const resolveModemTypeId = (raw, modemTypes) => {
  if (typeof raw !== 'string') return raw;
  const text = raw.trim();
  if (/^\d+$/.test(text)) return Number(text);
  const found = (modemTypes || []).find((type) => type && type.name === text);
  return found ? found.id : raw;
};
